export class SessionService {
  public static getObject(key: string): Object {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }
  public static setObject<T extends Object>(key: string, obj: T): void {
    if (obj || obj === null) {
      sessionStorage.setItem(key, JSON.stringify(obj));
    }
  }
  public static remove(key: string): void {
    sessionStorage.removeItem(key);
  }
  public static getString(key: string): string {
    return sessionStorage.getItem(key);
  }
  public static setString(key: string, str: string): void {
    sessionStorage.setItem(key, str);
  }
}
